import React, { Fragment } from 'react'
import {
  Box,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Button,
  Spinner,
  Text
} from '@chakra-ui/react'
import { Link } from 'react-router-dom';
import { MdOutlineChevronRight } from "react-icons/md";
import AllFillters from './Layout/AllFillters';


const AllOrderDelivery = ({ title, head, data, isLoading }) => {

    // const y = [...data].reverse()
    data.sort((a,b) => {
        return new Date(b.placedDate) - new Date(a.placedDate)
    })

    // status str format
    const convertStatus = (str) =>  {
        // Split the string by underscores
        var words = str.split('_');
      
        // Capitalize the first letter of each word
        for (var i = 0; i < words.length; i++) {
          words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
        }
      
        // Join the words with a space
        var result = words.join(' ');
      
        return result;
      }
      

  return (
    <Fragment>
    <AllFillters
             title={title}
             data={data}
             create={'Delivery Boy'}
            //  filters = {[{"Filter Notification":[{id: 'ORDER_TICKET', title: 'Order'}, {id: 'TENURE_TICKET', title: 'Tenure'}, {id: 'CUSTOMER_VERIFICATION_TICKET', title: 'Customer Verification'},
            //  {id: 'RETURN_TICKET', title: 'Return'} , {id: 'SETTLEMENT_TICKET', title: 'Settlement'}, {id: 'DISPUTE_TICKET', title: 'Dispute'}
            // ]}]}
            //  filters = {[{"Date": filterbyDate}, {"Profession": filterByProfession}]}
          />
   <Box maxW={'full'} my={{base: 2, md: 2, lg: 4, xl: 4, '2xl': 4}}>
   <TableContainer height={`${window.innerHeight - 244}px`} overflowY={'scroll'}>
                    <Table variant={'simple'} size={'xs'}>
                        <Thead bgColor={'gray.100'} position={'sticky'} top={'0px'} zIndex={'99'}>
                            <Tr bgColor={'#E2DFDF'}>
                                {head.map((h, i) => (
                                    <Th key={i} fontSize={{base: 'xs', md: 'xs', lg: 'xs', xl: 'xs', '2xl': 'sm'}} py={3} _first={{paddingLeft: '20px'}} color={'#25282B'}>{h}</Th>
                                ))}
                            </Tr>
                        </Thead>
                        <Tbody >
                        {(data.length > 0) ?
                        <>
                            {data.map((d, i) => (
                                
                                <Tr key={i}  bgColor={'white'}>
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3} pl={5}>{d?.OrderName.includes('#') ? d?.OrderName : 'Draft'}</Td>
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3}>{
                                        new Intl.DateTimeFormat('en-US', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric',
                                            hour: 'numeric',
                                            minute: 'numeric',
                                            hour12: true,
                                            timeZone: 'ASIA/KOLKATA'
                                          }).format(new Date(d.placedDate))
                                    }</Td>
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3}>{"Rs." + Number(d?.grandTotal).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    }) || "----"}</Td>
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3} pl={4} >{d.OrderItem.length}</Td>    
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3} pl={5}>{'01/01/2023'}</Td>
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3} pl={4}>
                                        <Button size={'xs'} cursor={'default'} colorScheme={(d?.orderStatusId === 'ORDER_CREATED' && 'green') ||
                                        (d?.orderStatusId === 'ORDER_PUBLISHED' && 'facebook') || 
                                        (d?.orderStatusId === 'ORDER_DRAFT' && 'purple') || 
                                        (d?.orderStatusId === 'ORDER_VERIFIED' && 'whatsapp') || 
                                        (d?.orderStatusId === 'ORDER_DELIVERED' && 'yellow') || 
                                        (d?.orderStatusId === 'ORDER_CANCELED' && 'red') || 
                                        (d?.orderStatusId === 'ORDER_OUT_FOR_DELIVERY' && 'orange') || 
                                        (d?.orderStatusId === 'ORDER_TRANSIT' && 'messenger') || 
                                        (d?.orderStatusId === 'ORDER_RETURNED' && 'telegram') || 
                                        (d?.orderStatusId === 'ORDER_PENDING_FOR_FULFILLMENT' && 'teal') || 
                                        (d?.orderStatusId === 'ORDER_READY_FOR_FULFILLMENT' && 'linkedin') || 
                                        (d?.orderStatusId === 'ORDER_PICKED' && 'pink') ||
                                        (d?.orderStatusId === 'AWAITING_VERIFICATION' && 'cyan')
                                        }>
                                                {convertStatus(d.orderStatusId).split(' ').filter((d) => d !== "Order").join(' ')}
                                    </Button>
                                    </Td>
                                   
                                   
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}}>
                                        <Flex>
                                            
                                            <Box bgColor={'gray.200'} rounded={'full'} my="auto" p={2} mx={2}>
                                                <Link to={`/order-delivery/details/${d.id}`}> <MdOutlineChevronRight /> </Link>
                                            </Box>
                                        </Flex>
                                    </Td>
                                </Tr>
                            ))}
                             </>
                         : 
                         <Tr>
                          <Td></Td>
                          <Td></Td>
                          <Td></Td>
                          <Td textAlign={'right'}>
                          {isLoading.loading === true ?
                            <Spinner
                            thickness='4px'
                            speed='0.65s'
                            emptyColor='gray.200'
                            color='blue.500'
                            size='xl'
                            mt={4}
                        
                          />
                          :
                          isLoading.error === true ? <Text fontWeight={'semibold'} color={'red.500'}>Oops we are facing some temporary issue with your request</Text> : <Text  fontWeight={'semibold'} color={'green.500'}>NO ORDERS AVAILABLE</Text>
                          }
                           </Td>
                          <Td></Td>
                          <Td></Td>
                          <Td></Td>
                         </Tr>
                        }
                        </Tbody>        
                    </Table>
                </TableContainer>
         </Box>
 </Fragment>
  )
}

export default AllOrderDelivery